export default theme => ({
  searchBox: {
    display: "flex",
    alignItems: "baseline",
  },
  select_label: {
    fontSize: 12,
  },
  scoreboardPreview: {
    border: "1px solid",
    maxHeight: 300,
    width: "auto",
    backgroundColor: "rgba(0,0,0,0.2)",
    cursor: "pointer",
  },
  scoreboardPreview_container: {
    textAlign: "center",
  },
  scoreboardPreview_image: {
    maxWidth: 300,
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  fullWidth: {
    width: "100%",
  },
  scoreboardTemplateSelector: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(6)
  },
  selectedScoreboardTemplateSelector: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(6)
  },
  preview_image: {
    width: "100%",
    height: "auto",
    maxWidth: 300,
  }
});
